import _objectSpread from "F:\\07_development\\google-chrome\\02_projects\\adaptive-loading\\react-youtube-adaptive-loading\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "F:\\07_development\\google-chrome\\02_projects\\adaptive-loading\\react-youtube-adaptive-loading\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";

/*
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { useState, useEffect } from 'react';
var unsupported;

var useNetworkStatus = function useNetworkStatus() {
  if ('connection' in navigator && 'effectiveType' in navigator.connection) {
    unsupported = false;
  } else {
    unsupported = true;
  }

  var initialNetworkStatus = !unsupported ? {
    effectiveConnectionType: navigator.connection.effectiveType
  } : {
    unsupported: unsupported
  };

  var _useState = useState(initialNetworkStatus),
      _useState2 = _slicedToArray(_useState, 2),
      networkStatus = _useState2[0],
      setNetworkStatus = _useState2[1];

  useEffect(function () {
    if (!unsupported) {
      var navigatorConnection = navigator.connection;

      var updateECTStatus = function updateECTStatus() {
        setNetworkStatus({
          effectiveConnectionType: navigatorConnection.effectiveType
        });
      };

      navigatorConnection.addEventListener('change', updateECTStatus);
      return function () {
        navigatorConnection.removeEventListener('change', updateECTStatus);
      };
    }
  }, []);
  return _objectSpread({}, networkStatus, {
    setNetworkStatus: setNetworkStatus
  });
};

export { useNetworkStatus };